import { render } from "./notify-list.vue?vue&type=template&id=5a6e6eab&scoped=true&lang=true"
import script from "./notify-list.vue?vue&type=script&lang=js"
export * from "./notify-list.vue?vue&type=script&lang=js"

import "./notify-list.vue?vue&type=style&index=0&id=5a6e6eab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6e6eab"]])

export default __exports__